import { FuelGasContractStatusBase } from './base/fuel-gas-contract-status-base';

export class FuelGasContractStatus extends FuelGasContractStatusBase { }